/*       */

export const getUserReferences = (state) => state.admin.users.references.data || [];

export const getActiveUserReferences = (state) => getUserReferences(state).filter(u => u.active);
